export default __webpack_public_path__ + "static/media/XEMP-8.3189a33e.jpg";